import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import CompSource from '../../CompSource';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { startDragLinkingLine } from "../../../lib/utils/browser";
import { DND_TYPE_DATA_PATH, DND_TYPE_LAYOUT, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import getTypeIcon from '../../assets/typeIcons';
import AlternativeForDataSourcePopover from '../MaterialBox/AlternativeForDataSourcePopover';
import { arrayify } from "../../../lib/utils/array";
import { isPrimitive } from 'vue-class-component/lib/util';
import { getFitDataLayout } from "../../../lib/utils";
const DSTreeNode = {
  name: 'DSTreeNode',
  props: {
    name: String,
    stub: Object,
    dataPath: String,
    depth: Number,
    // 层级不同，样式会有些差异
    expandable: Boolean,
    expanded: Boolean,
    toggleExpansion: Function,
    lineExpansion: Boolean,
    showObjectValue: Boolean,
    draggable: Boolean,
    id: String
  },
  // slots: after
  inject: {
    MaterialBox: {
      from: 'MaterialBox',
      default: null
    },
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    },
    dataSourceTreeContext: {}
  },
  data() {
    return {
      comp: null,
      // 这个 stub 对应的 UICore.Layout，会在鼠标进入时动态更新
      hasBindings: false,
      // 在 watch 里显式更新
      deps: [],
      // 在 mouseenter 时更新，同样是担心性能问题
      showFiexd: false,
      fitDataResult: null,
      fitDataResultArray: null
    };
  },
  computed: {
    dataPathParts() {
      var _this$stub;
      return ((_this$stub = this.stub) === null || _this$stub === void 0 ? void 0 : _this$stub.pathParts) || [];
    },
    type() {
      var _this$stub2;
      return ((_this$stub2 = this.stub) === null || _this$stub2 === void 0 ? void 0 : _this$stub2.type) || 'any';
    },
    /**
     * @returns {UICore.Designer.DragSourceBase}
     */
    designerDragSource() {
      return {
        layout: this.comp
      };
    },
    isBindable() {
      var _this$stub3;
      return ((_this$stub3 = this.stub) === null || _this$stub3 === void 0 ? void 0 : _this$stub3.schema['uc:bindable']) !== false;
    },
    isRoot() {
      return this.depth === 0;
    },
    stateTags() {
      var _this$stub4;
      const raw = (_this$stub4 = this.stub) === null || _this$stub4 === void 0 || (_this$stub4 = _this$stub4.schema) === null || _this$stub4 === void 0 ? void 0 : _this$stub4['uc:tag'];
      if (raw) return arrayify(raw);
    },
    // 只在mouseEnter的时候被触发并计算 拖动compSource的时候 要把fitDataResult给通知到designer 这里缓存一份
    fitDataResultArrayTemped() {
      const res = this.uc.fitData(this.dataPath, undefined, {
        compTypeFilter: 'all'
      });
      return Object.freeze(res);
    }
  },
  methods: {
    /** @param {DragEvent} ev */
    handleBindingDragStart(ev) {
      const {
        dataPath,
        isBindable
      } = this;
      const {
        dataTransfer
      } = ev;

      // eslint-disable-next-line eqeqeq
      if (dataPath == null) return;
      if (!isBindable) return;
      dataTransfer.setData('text/plain', `{{ ${dataPath} }}`);
      dataTransfer.setData(DND_TYPE_DATA_PATH, dataPath);
      this.designer.currentOperation = 'binding';
      this.designer.currentBindingDataStub = this.stub;
      const rect = ev.target.getBoundingClientRect();
      startDragLinkingLine({
        startX: rect.left + rect.width / 2,
        startY: rect.top + rect.height / 2,
        lineClassName: 'ucd-bindingLine'
      });
    },
    handleBindingDragEnd() {
      this.designer.currentOperation = '';
      this.designer.currentBindingDataStub = null;
    },
    handleMouseEnter() {
      var _getFitDataLayout, _this$designer$deps;
      // 左侧面板的组件推荐面板 推荐时筛选全部组件 鼠标划入时才把computed fitDataResultTemped真正执行
      this.comp = Object.freeze((_getFitDataLayout = getFitDataLayout(this.fitDataResultArrayTemped[0])) === null || _getFitDataLayout === void 0 ? void 0 : _getFitDataLayout.layout);
      this.fitDataResult = Object.freeze(this.fitDataResultArrayTemped[0]);
      this.fitDataResultArray = this.fitDataResultArrayTemped;
      this.deps = Object.freeze(Array.from(((_this$designer$deps = this.designer.deps) === null || _this$designer$deps === void 0 ? void 0 : _this$designer$deps.getChildNode(this.dataPathParts)) || [], x => x.value));
      this.deps.forEach(({
        compPath
      }) => {
        this.designer.setHighlight(compPath, 'normal');
      });
      if (this.MaterialBox) {
        this.MaterialBox.currentHoveringDataPath = this.dataPath;
      }
    },
    handleMouseLeave() {
      this.deps.forEach(({
        compPath
      }) => {
        this.designer.setHighlight(compPath, false);
      });
      if (this.MaterialBox) {
        this.MaterialBox.currentHoveringDataPath = '';
      }
    },
    handleClick(event) {
      if (this.lineExpansion) {
        var _this$toggleExpansion;
        (_this$toggleExpansion = this.toggleExpansion) === null || _this$toggleExpansion === void 0 || _this$toggleExpansion.call(this);
      }
      // 点击折叠按钮 将不触发click事件 在materialbox中 click事件仅用于触发高亮 所以不影响
      if (event.target.matches('[data-toggle-expansion], [data-toggle-expansion] *')) return;
      this.$emit('click', this);
    },
    onRootClick() {
      var _this$toggleExpansion2;
      (_this$toggleExpansion2 = this.toggleExpansion) === null || _this$toggleExpansion2 === void 0 || _this$toggleExpansion2.call(this);
    },
    handleExpansionClick() {
      if (!this.lineExpansion) {
        var _this$toggleExpansion3;
        (_this$toggleExpansion3 = this.toggleExpansion) === null || _this$toggleExpansion3 === void 0 || _this$toggleExpansion3.call(this);
      }
    },
    /**
     * 从 designer 同步当前是否已经 binded
     */
    syncBindStatus() {
      var _designer$deps;
      const {
        dataPathParts,
        designer
      } = this;

      // 如果树存在，就说明存在依赖
      this.hasBindings = !!((_designer$deps = designer.deps) !== null && _designer$deps !== void 0 && _designer$deps.getChildNode(dataPathParts));
    },
    compSourceSetData(dataTransfer) {
      const {
        dataPath
      } = this;
      if (!dataPath) return;
      dataTransfer.setData('text/plain', `{{ ${dataPath} }}`);
      dataTransfer.setData(DND_TYPE_DATA_PATH, this.dataPath);
      dataTransfer.setData(DND_TYPE_LAYOUT, JSON.stringify(this.comp));
    },
    renderExpand() {
      const h = this.$createElement;
      const {
        expandable
      } = this;
      return expandable || this.isRoot ? h("i", _mergeJSXProps([{
        "class": ['ucd-dataTreeNode-expand', `fa fa-${this.expanded ? 'caret-down' : 'caret-right'}`],
        "attrs": {
          "aria-hidden": "true",
          "data-toggle-expansion": expandable,
          "title": expandable ? '点击展开/收起' : ''
        }
      }, {
        "on": {
          click: this.handleExpansionClick
        }
      }])) : h("div", {
        "class": "ucd-dataTreeNode-expand"
      });
    },
    renderSummary() {
      const h = this.$createElement;
      const {
        stub,
        type
      } = this;
      if (type === 'array' || type === 'object') {
        return this.getArraySumary();
      }
      const summary = getValeuText(type, stub.value);
      return summary ? h("div", {
        "class": "ucd-dataTreeNode-summary"
      }, [summary]) : null;
    },
    getArraySumary() {
      const h = this.$createElement;
      const {
        stub
      } = this;
      const {
        value
      } = stub;
      const renderText = text => {
        const textLine = h("div", {
          "class": 'ucd-dataTreeNode-summary'
        }, [text]);
        return textLine;
      };
      if (isPrimitive(value)) {
        return renderText(getValeuText(typeof value, value));
      }
      if (typeof value === 'object' && value !== null && isShowViewValue(this)) {
        const isArray = Array.isArray(value);
        const text = isArray ? `[…] length:${value.length}` : '{...}';
        return h("div", {
          "class": "ucd-dataTreeNode-array-summary"
        }, [renderText(text, isArray ? 'array' : 'object'), this.showObjectValue && h("a-tooltip", {
          "attrs": {
            "title": "查看具体数值"
          }
        }, [h("div", {
          "class": "ucd-dataTreeNode-actionIconButton-icon",
          "on": {
            "click": this.toViewValue
          }
        }, [h("a-icon", {
          "attrs": {
            "type": "eye"
          }
        })])])]);
      }
    },
    renderId() {
      const h = this.$createElement;
      if (this.name.includes(this.id) || this.depth === 0) return undefined;
      // id不同时 在右侧面展示
      return h("div", {
        "class": 'ucd-dataTreeNode-id'
      }, [this.id]);
    },
    renderChildNode() {
      var _this$MaterialBox, _ref, _this$designer, _this$designer$getHig, _this$stateTags, _this$$slots;
      const h = this.$createElement;
      const {
        name,
        comp,
        type,
        isRoot,
        expandable,
        designerDragSource,
        dataPath,
        draggable
      } = this;
      const isHovering = ((_this$MaterialBox = this.MaterialBox) === null || _this$MaterialBox === void 0 ? void 0 : _this$MaterialBox.currentHoveringDataPath) === dataPath;
      const isHighlight = (_ref = ((_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer$getHig = _this$designer.getHighlightDataPath) === null || _this$designer$getHig === void 0 ? void 0 : _this$designer$getHig.call(_this$designer)) === dataPath) !== null && _ref !== void 0 ? _ref : false;

      // const needHighlight = type !== 'object' && !hasBindings;
      const w = this.getScrollWidth();
      return h("div", {
        "class": mergeClassName('ucd-dataTreeNode', isHighlight && 'ucd-dataTreeNode-highlight', isRoot && 'isRoot', expandable && 'isExpandable', isHovering && 'isHover' /* , needHighlight && 'ucd-dataTreeNode--highlighted' */),
        "attrs": {
          "data-type": type,
          "guide-el": `data-path-${this.dataPath}`,
          "ds-data-path": this.dataPath
        },
        "on": {
          "mouseenter": this.handleMouseEnter,
          "mouseleave": this.handleMouseLeave,
          "click": this.handleClick
        },
        "style": isRoot ? {
          width: w > 0 ? `${w}px` : '100%'
        } : ''
      }, [h(CompSource, {
        "attrs": {
          "draggable": draggable,
          "value": comp,
          "dragSource": designerDragSource,
          "setData": this.compSourceSetData,
          "fitDataResult": this.fitDataResult
        }
      }, [h("div", {
        "class": "ucd-dataTreeNode-name"
      }, [
      // 对于根节点，要区分可展开/不可展开的渲染方式
      // 对于其他的普通节点，都渲染吧，没错的

      // eslint-disable-next-line no-nested-ternary
      isRoot ? expandable ? this.renderExpand() : h("img", {
        "class": "ucd-dataTreeNode-icon",
        "attrs": {
          "src": getTypeIcon(type)
        }
      }) : [this.renderExpand(), h("img", {
        "class": "ucd-dataTreeNode-icon",
        "attrs": {
          "src": getTypeIcon(type),
          "data-toggle-expansion": expandable,
          "title": expandable ? '点击展开/收起' : ''
        }
      })], name, h("span", {
        "class": "ucd-dataTreeNode-path"
      }, ["\xA0", isRoot ? `(${dataPath})` : '']), (_this$stateTags = this.stateTags) === null || _this$stateTags === void 0 ? void 0 : _this$stateTags.map((tag, idx) => h("span", {
        "class": "ucd-dataTreeNode-state-tag",
        "key": `tag-${idx}`
      }, [tag]))]), this.renderSummary(), !isHovering && this.renderId()]), (isRoot || isHovering) && h("div", {
        "class": ['ucd-dataTreeNode-actionsWrapper', isRoot ? '' : 'ucd-dataTreeNode-actionsWrapper-bg']
      }, [(_this$$slots = this.$slots) === null || _this$$slots === void 0 ? void 0 : _this$$slots.after, this.isBindable && h("div", {
        "class": "ucd-dataTreeNode-actionIconButton",
        "style": "cursor: alias",
        "attrs": {
          "draggable": true
        },
        "on": {
          "dragstart": this.handleBindingDragStart,
          "dragend": this.handleBindingDragEnd
        }
      }, [h("a-tooltip", {
        "attrs": {
          "title": "拖拽到组件上，可执行数据绑定",
          "overlayClassName": "ucd-dataTreeNode-actionIconButton-tooltip"
        }
      }, [h("div", {
        "class": "ucd-dataTreeNode-actionIconButton-icon"
      }, [h("img", {
        "attrs": {
          "width": "16",
          "height": "16",
          "src": require('../../assets/link.png')
        }
      })])])]), /* 备选组件面板 */
      isHovering && h(AlternativeForDataSourcePopover, {
        "attrs": {
          "dataPath": dataPath,
          "fitDataResultTemped": this.fitDataResultArray
        }
      })])]);
    },
    getScrollWidth() {
      return this.dataSourceTreeContext.treeState.panelState.scrollWidth;
    },
    /**
     * @param {UIEvent} e
     */
    toViewValue(e) {
      e.stopPropagation();
      this.designer.$emit('view-value', this.stub);
    }
  },
  render() {
    return this.renderChildNode();
  },
  created() {
    this.$watch('dataPath', this.syncBindStatus);
    this.designer.$on('deps-updated', this.syncBindStatus);
    this.syncBindStatus();
  },
  beforeDestroy() {
    this.designer.$off('deps-updated', this.syncBindStatus);
  }
};
function getValeuText(type, val) {
  let res;
  if (val === undefined) return 'undefined';
  if (val === null) return 'null';
  switch (type) {
    case 'boolean':
      res = String(val);
      break;
    case 'number':
      res = String(val);
      break;
    case 'string':
      res = typeof val === 'string' ? `"${String(val).substr(0, 64)}"` : String(val);
      break;
    default:
      res = null;
      break;
  }
  return res;
}
function isShowViewValue(ctx) {
  var _stub$pathParts;
  const {
    stub,
    depth
  } = ctx;
  if (((_stub$pathParts = stub.pathParts) === null || _stub$pathParts === void 0 ? void 0 : _stub$pathParts[0]) === 'data') {
    return depth >= 2;
  }
  return depth >= 1;
}
export default DSTreeNode;
//# sourceMappingURL=DSTreeNode.js.map
